import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { showNotification } from "../../utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { ProgressSpinner } from "primereact/progressspinner";
import { TriStateCheckbox } from "primereact/tristatecheckbox";
import "./historial.css";

const Historial = () => {
  const [classesData, setClassesData] = useState([]);
  const [targetDate, setTargetDate] = useState("");
  const [expandedRows, setExpandedRows] = useState(null);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    start_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    end_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    language: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    location: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    location_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    teacher_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    books: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    capacity: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [loading, setLoading] = useState(false); // Estado de carga
  const navigate = useNavigate();
  const toast = useRef(null);

  const handleSearch = () => {
    if (!targetDate) {
      showNotification("Error", "Por favor, selecciona una fecha", "warning");
      return;
    }

    setLoading(true); // Iniciar carga
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/classes?targetDate=${targetDate}`;
    fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("token"),
      },
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw new Error(data.message);
          });
        } else if (response.status === 200) {
          console.log("Clases cargadas");
          return response.json();
        }
      })
      .then((data) => {
        setClassesData(data);
        // Load assistance for each class
        data.forEach((classData) => {
          handleSearchAssistance(classData.id);
          console.log(classData);
        });
      })
      .catch((error) => {
        showNotification("Error", error.message, "warning");
        setClassesData([]);
      })
      .finally(() => {
        setLoading(false); // Finalizar carga
      });
  };

  const handleSearchAssistance = (id) => {
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/class/${id}/assistance`;
    fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("token"),
      },
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw new Error(data.message);
          });
        } else if (response.status === 200) {
          console.log("Estudiantes cargados");
          return response.json();
        }
      })
      .then((data) => {
        setClassesData((prevClassesData) =>
          prevClassesData.map((classData) =>
            classData.id === id ? { ...classData, assistance: data } : classData
          )
        );
        console.log(data);
      })
      .catch((error) => {
        showNotification("Error", error.message, "warning");
      });
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const renderHeader = () => {
    return (
      <div className="flex justify-content-end box_key_word">
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Keyword Search"
          />
        </IconField>
      </div>
    );
  };

  /*const statusRowFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={statuses}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder="Select One"
        className="p-column-filter"
        showClear
        style={{ minWidth: "12rem" }}
      />
    );
  };*/

  const verifiedRowFilterTemplate = (options) => {
    return (
      <TriStateCheckbox
        value={options.value}
        onChange={(e) => options.filterApplyCallback(e.value)}
      />
    );
  };

  const booksTemplate = (rowData) => {
    if (!rowData.books || rowData.books.length === 0) {
      return "Sin libros";
    }

    return (
      <ul style={{ paddingLeft: "15px", margin: 0 }}>
        {rowData.books.map((book, index) => (
          <li key={index}>{book}</li>
        ))}
      </ul>
    );
  };

  const header = renderHeader();

  const onRowExpand = (event) => {};

  const onRowCollapse = (event) => {};

  const handleClear = () => {
    setTargetDate("");
    setClassesData([]);
  };

  const rowExpansionTemplate = (data) => {
    return (
      <div className="p-3">
        <h5>Lista estudiantes para sesion {data.id}</h5>
        <DataTable value={data.assistance || []}>
          <Column field="customer_id" header="ID Estudiante" sortable></Column>
          <Column field="full_name" header="Nombre" sortable></Column>
          <Column
            field="session_name"
            header="Nombre de la sesion"
            sortable
          ></Column>
        </DataTable>
      </div>
    );
  };

  return (
    <div className="historial-container">
      {loading && (
        <>
          <div className="loading-overlay"></div>
          <div className="loading-spinner">
            <ProgressSpinner />
          </div>
        </>
      )}

      <div className="search-container">
        <input
          type="date"
          className="date_picker"
          value={targetDate}
          onChange={(e) => setTargetDate(e.target.value)}
        />
        <button
          className="button_handleSC"
          onClick={handleSearch}
          disabled={loading}
        >
          {loading ? "Buscando..." : "Buscar"}
        </button>
        <button
          className="button_handleSC"
          onClick={handleClear}
          disabled={loading}
        >
          Limpiar
        </button>
      </div>

      <div className="historial-container_data-table">
        <DataTable
          value={classesData}
          tableStyle={{ minWidth: "50rem" }}
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          onRowExpand={onRowExpand}
          onRowCollapse={onRowCollapse}
          rowExpansionTemplate={rowExpansionTemplate}
          globalFilterFields={[
            "id",
            "start_date",
            "end_date",
            "language",
            "location",
            "location_name",
            "type",
            "teacher_name",
            "books",
            "capacity",
          ]}
          filters={filters}
          header={header}
          paginator
          rows={5}
          CurrentPageReport
          emptyMessage="No hay clases en esta fecha"
        >
          <Column field="id" sortable header="ID de Clase"></Column>
          <Column field="start_date" sortable header="Fecha inicio"></Column>
          <Column field="end_date" sortable header="Fecha fin"></Column>
          <Column field="language" sortable header="Lenguaje"></Column>
          <Column field="location" sortable header="Ubicacion"></Column>
          <Column
            field="location_name"
            sortable
            header="Nombre ubicacion"
          ></Column>
          <Column field="type" sortable header="Tipo"></Column>
          <Column
            field="teacher_name"
            sortable
            header="Nombre profesor"
          ></Column>
          <Column
            field="books"
            sortable
            header="Libros"
            body={booksTemplate}
          ></Column>
          <Column field="capacity" sortable header="Capacidad"></Column>
          <Column
            field="students_registered"
            sortable
            header="Estudiantes registrados"
          ></Column>
          <Column expander header="Ver estudiantes" />
        </DataTable>
      </div>
    </div>
  );
};

export default Historial;
